import {
    APIAppInstanceModel,
    AppInstanceListParams,
    defaultParams
} from "../Models/API/AppInstanceModel"
import { useAppState } from "./useReduxState"
import { FetchState } from "../Models/Client/FetchState"
import { getItemList, getPageToFetch } from "../Models/Client/RemoteData"
import { Result } from "../Models/Utility/Result"
import { useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import { getCustomerAppList } from "../Actions/API/Backoffice/BackofficeActions"
import { Customer } from "../Models/API/BackofficeModel"

const defaultAppListParams: AppInstanceListParams = {
    ...defaultParams,
    showArchived: true
}
export function useCustomerAppList(customer: Customer): FetchState<{
    items: APIAppInstanceModel[]
    total: number
}> {
    const dispatch = useDispatch()
    const entry = useAppState(
        state => state.api.backoffice.customerApps[customer.username]
    )

    useEffect(() => {
        const page = getPageToFetch(entry, defaultAppListParams) // update if actions are added

        if (page >= 0) {
            dispatch(getCustomerAppList(customer, defaultAppListParams, page))
        }
    }, [dispatch, entry, customer])

    return useMemo(() => {
        if (entry === undefined || entry.list === undefined) {
            return undefined
        }

        return Result.ok({
            items: getItemList(entry),
            total: entry.list.total
        })
    }, [entry])
}
